<template>
  <ResponsiveConfirmDialog
    :show="show"
    :title="__('Logout')"
    role="alertdialog"
    size="sm"
    stack-priority="top"
    @close="handleClose"
    @close-via-escape="handleClose"
  >
    <div
      class="panel-confirm-dialog max-md:!bg-transparent overflow-hidden rounded-3xl border border-zinc-200/70 bg-white shadow-2xl dark:border-zinc-800 dark:bg-zinc-900 dark:max-md:!bg-transparent max-md:rounded-none max-md:border-0 max-md:shadow-none"
    >
      <ModalHeader class="max-md:hidden" v-text="__('Logout')" />
      <ModalContent>
        <p class="leading-relaxed">
          {{ __('Are you sure you want to log out?') }}
        </p>
      </ModalContent>
      <ModalFooter class="max-md:hidden">
        <div class="panel-confirm-footer-actions ml-auto flex w-full items-center">
          <LinkButton
            type="button"
            class="mr-3"
            dusk="cancel-logout-button"
            @click.prevent="handleClose"
          >
            {{ __('Cancel') }}
          </LinkButton>

          <Button
            ref="confirmButton"
            type="button"
            dusk="confirm-logout-button"
            :loading="working"
            state="danger"
            :label="__('Logout')"
            @click.prevent="handleConfirm"
          />
        </div>
      </ModalFooter>
    </div>

    <template #footer>
      <div class="panel-confirm-footer-actions panel-confirm-footer-actions--sheet w-full">
        <LinkButton
          type="button"
          class="flex-1 justify-center"
          dusk="cancel-logout-button"
          @click.prevent="handleClose"
        >
          {{ __('Cancel') }}
        </LinkButton>

        <Button
          class="flex-1"
          dusk="confirm-logout-button"
          :loading="working"
          state="danger"
          :label="__('Logout')"
          @click.prevent="handleConfirm"
        />
      </div>
    </template>
  </ResponsiveConfirmDialog>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import { mapActions } from 'vuex'
import { Button } from 'laravel-nova-ui'

export default {
  components: {
    Button,
  },

  data: () => ({
    show: false,
    working: false,
  }),

  mounted() {
    Nova.$on('confirm-logout', this.open)
  },

  beforeUnmount() {
    Nova.$off('confirm-logout', this.open)
  },

  methods: {
    ...mapActions(['logout']),

    open() {
      this.show = true
    },

    handleClose() {
      this.show = false
      this.working = false
    },

    async handleConfirm() {
      this.working = true

      try {
        const redirect = await this.logout(Nova.config('customLogoutPath'))

        if (redirect !== null) {
          location.href = redirect
          return
        }

        Nova.redirectToLogin()
      } catch (e) {
        Inertia.reload()
      } finally {
        this.working = false
        this.show = false
      }
    },
  },
}
</script>
